angular.module('cvsApp').service('registerSpecialtyUser', ['networkService', 'xdrService', 'configManager', 'commonModel', 'quickRegistrationModel', function (NS, XS, CM, CMOD, QRM) {

	function registerSpecialtyUser() {
		var self = this;
		this.userRegister = function (email, 
			verifiedBy, 
			appRefNo, 
			encryptedPassword, 
			encryptedKey, 
			accessKey, 
			regType,
			userAcceptedAgreement,
			callBackSuccess) {
			var reqBody = {
				"appRefNumber": appRefNo,
				"password": encryptedPassword,
				"encKey": encryptedKey,
				"userAcceptedAgreement": userAcceptedAgreement,
				"fastIndicator": 'Yes',
				"verifiedBy": verifiedBy,
				"regType": regType,
				"email": email,
				"accessKey": accessKey
			};

			//get url 
			var url = CM.getAPIGEEAPIUrl('SPECIALTY_USER_REGISTER_APIGEE');
			if (cvsUtility.queryMap.env === 'local') {
				url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env] + "/specialty/registration/v1/user-registration";
			}
			else {
				url = CVS.Config.parentHost.Web[cvsUtility.queryMap.env] + "/apims/specialty/" + CVS.Config.services['SPECIALTY_USER_REGISTER_APIGEE'].URL;
			}
			if (url === "URL_ERROR") {

			} else {
				var request = {
					url: url,
					header: {
						"Content-Type": "application/json",
						"Accept": "application/json",
						'x-api-key': cvsUtility.queryMap.env == 'prod' ? 'BlmvsMWWqssGvPMVG1mA4kymUwWEqDmg' : 'UCdFZ5ivOA0gSA0QbmqIFvY4j7CTjTtP'
					},
					data: reqBody,
					onSuccess: callBackSuccess
				};

				//cvsUtility.commonServiceCode(url, self, request, callBackSuccess, NS);

				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, "", xdrSuccess);

					function xdrSuccess(data) {
						// QRM.setResponse(data);
						// callBackSuccess(QRM.getResponse());
						callBackSuccess(data);
					}
				} else {
					var authPromise = NS.post(request);
					authPromise.then(function (data) {
						// QRM.setResponse(data.data);
						// callBackSuccess(QRM.getResponse());
						callBackSuccess(data.data);
					}, function (reason) {
						callBackSuccess(reason);
					});
				}
			};

		};

		var response = '';

		this.setResponse = function (data) {
			data = data.replace(/[\n\r\t]+/g, "");
			response = cvsUtility.xmlToJSON(data);

		};
		this.getResponse = function () {
			return response;
		};
	}

	return new registerSpecialtyUser();
}]);
